module.exports = __webpack_public_path__ + "img/car-electric-first_ec-phev.55d894f5.png";